"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformEnum = void 0;
var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["WHATSAPP"] = "whatsapp";
    PlatformEnum["APP"] = "app";
    PlatformEnum["TERMINAL"] = "terminal";
    PlatformEnum["SMS"] = "sms";
})(PlatformEnum || (exports.PlatformEnum = PlatformEnum = {}));
//# sourceMappingURL=platform.types.js.map